module.exports = __webpack_public_path__ + "static/media/RadicalBike.456f6668.jpg";